import React from 'react';
import ReappraisalRationaleStatus from './ReappraisalRationaleStatus';
import AppraisalDetailStatus from './AppraisalDetailStatus';
import DirectChannelWarning from './DirectChannelWarning';

/**
 * @typedef {object} EventStatusWarningsProps
 * @property {Array<*>} [warningTypes]
 * @property {boolean} [showAppraisalDetailStatus]
 */

/**
 * @param {EventStatusWarningsProps} props
 */
const EventStatusWarnings = props => {
  const { warningTypes = [], showAppraisalDetailStatus = false } = props;

  return (
    <div data-testid='event-status-warnings'>
      <ReappraisalRationaleStatus warningTypes={warningTypes} />
      {showAppraisalDetailStatus && <AppraisalDetailStatus warningTypes={warningTypes} />}
      <DirectChannelWarning warningTypes={warningTypes} />
    </div>
  );
};

export default EventStatusWarnings;
